import { request } from "@/interface/helper";

const str = "senum";

export const senum = {
  [`${str}`]: {
    getList: data => request({ data, method: "get", url: "/setting/enum/list" }),
    add: data => request({ data, method: "post", url: "/setting/enum/add" }),
    detail: data => request({ data, method: "post", url: "/setting/enum/detail" }),
    edit: data => request({ data, method: "post", url: "/setting/enum/modify" }),
    transfer: data => request({ data, method: "get", url: "/setting/enum/transfer" }),
    setLangDetail: data => request({ data, method: "post", url: "/setting/enum/setlangdetail" }),
    Export: data => request({ data, method: "get", url: "/setting/enum/export" }),
  }
};
